import React, { useEffect, useState } from "react";
import { TbDownload, TbLogs } from "react-icons/tb";
import LineChartStatus from "../../Components/Charts/LineChart";
import { IoChevronDown, IoChevronUp, IoReload } from "react-icons/io5";
import FormatDateTime from "../../Functions/FormatDate";
import SingleLoaderItem from "../../Loaders/SingleLoaderItem";
import { BiDollar, BiEuro, BiMinus, BiPlus } from "react-icons/bi";
import MandatorySign from "../../Components/MandatorySign";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const UsagePayment = ({ account_id }) => {
    const { t } = useLanguage()
    const [openLog, setOpenLog] = useState("")
    const [apiLogs, setApiLogs] = useState([])
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [loadingTransactions, setLoadingTransactions] = useState(false)
    const [transactions, setTransactions] = useState([])
    const [loadingDownload, setLoadingDownload] = useState(false)

    const getTransactions = async () => {
        setLoadingTransactions(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_transactions`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            setTransactions(data.transactions)

        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingTransactions(false);
        }
    };

    const downloadCSV = () => {
        setLoadingDownload(true)

        if (!transactions || transactions.length === 0) {
            setLoadingDownload(false)
            return
        };

        setTimeout(() => {
            const headers = ["Group", "Amount ($)"];

            const rows = transactions.map((t) => [
                t.group,
                t.amount_nano / 1_000_000_000
            ]);

            const csvContent = [
                headers.join(","),
                ...rows.map((row) => row.map(value => `"${value}"`).join(",")),
            ].join("\n");

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "transactions.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoadingDownload(false)
        }, 2000);

    };

    useEffect(() => {
        getTransactions()
    }, [])


    return (
        <div className="analytics_cont_body_inner">
            <div className="analytics_cont_body_inner_chart_cont">
                <div className="chart_header">
                    <p className="chart_header_title fade-in">{t.billing.usage_activity}</p>
                    <div className="editor_terminal_header_btn_cont">
                        <button className="analytics_cont_header_title_btn" onClick={downloadCSV}>
                            {loadingDownload ? (
                                <Spinner loading={true} />
                            ) : (
                                <>
                                    <TbDownload />
                                    {t.billing.download_csv}
                                </>
                            )}
                        </button>
                        <button className="main_mcp_cont_chat_btn fade-in" onClick={getTransactions}>
                            {loadingTransactions ? (
                                <Spinner loading={true} />
                            ) : (
                                <IoReload />
                            )}
                        </button>
                    </div>
                </div>

                <div className="usage_activity_cont fade-in">
                    {loadingTransactions ? (
                        <SingleLoaderItem length={5} />
                    ) : (
                        transactions.length > 0 ? (
                            transactions.map((transaction) => (
                                <div className="wallet_body_body_item fade-in">
                                    <div className="wallet_body_body_item_inner">
                                        {transaction.group == "top-up" || transaction.group == "auto top-up" ? (
                                            <span className="wallet_body_body_item_type wallet_body_body_item_type_plus"><BiPlus /></span>
                                        ) : (
                                            <span className="wallet_body_body_item_type wallet_body_body_item_type_minus"><BiMinus /></span>
                                        )}
                                        <p>
                                            {transaction.group}
                                        </p>

                                    </div>
                                    <div className="wallet_body_body_item_end">
                                        <p>
                                            <i>
                                                <BiDollar />
                                            </i>
                                            {(transaction.amount_nano) / 1_000_000_000}
                                        </p>
                                        {/* <p>
                                            {FormatDateTime(transaction.created_at)}
                                        </p> */}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="empty_chart">
                                <p>{t.no_data}</p>
                            </div>
                        )
                    )}

                </div>
            </div>
        </div>
    );
};

export default UsagePayment;